<template>
  <div class="container">
    <div class="school-body-index">
      <el-tabs v-model="activeName">
        <el-tab-pane label="我的班级" name="first">
          <el-row>
            <el-col :span="24">
              <div class="classwrapper" style="text-align: center">
                <div style="margin-top: 20%" v-if="classList.length == 0">
                  <svg
                    t="1650598706126"
                    class="icon"
                    viewBox="0 0 1567 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="5576"
                    width="200"
                    height="200"
                  >
                    <path
                      d="M156.662278 699.758173h21.097186A10.444152 10.444152 0 0 1 187.994733 710.202325c0 5.765172-4.490985 10.444152-10.235269 10.444152H156.662278v21.097186A10.444152 10.444152 0 0 1 146.218126 751.978932a10.277045 10.277045 0 0 1-10.444152-10.235269V720.646477H114.676787A10.444152 10.444152 0 0 1 104.441518 710.202325c0-5.765172 4.490985-10.444152 10.235269-10.444152H135.773974v-21.097187A10.444152 10.444152 0 0 1 146.218126 668.425717c5.765172 0 10.444152 4.490985 10.444152 10.235269v21.097187z m1378.628042-83.553215v-21.097186A10.277045 10.277045 0 0 0 1524.846168 584.872503a10.444152 10.444152 0 0 0-10.444152 10.235269v21.097186h-21.097186a10.277045 10.277045 0 0 0-10.235269 10.444152c0 5.598065 4.595427 10.444152 10.235269 10.444152h21.097186v21.097187c0 5.744284 4.67898 10.235269 10.444152 10.235268a10.444152 10.444152 0 0 0 10.444152-10.235268V637.093262h21.097187c5.744284 0 10.235269-4.67898 10.235268-10.444152a10.444152 10.444152 0 0 0-10.235268-10.444152H1535.29032zM776.460024 960.861969H250.596979A20.80475 20.80475 0 0 1 229.77134 939.973665c0-11.530344 9.462402-20.888304 20.825639-20.888303h94.728457A83.010119 83.010119 0 0 1 334.212859 877.413196v-605.96969A83.49055 83.49055 0 0 1 417.849627 187.994733H480.430984V167.001988A83.49055 83.49055 0 0 1 564.067752 83.553215h501.152182A83.448773 83.448773 0 0 1 1148.856702 167.001988v605.969689c0 15.185797-4.052331 29.410732-11.133466 41.672166h115.554096c11.551232 0 20.909192 9.274407 20.909192 20.888304 0 11.530344-9.295295 20.888304-20.888304 20.888304H1002.638576v20.992745c0 15.185797-4.052331 29.410732-11.133466 41.672166h11.196131c11.488567 0 20.825639 9.274407 20.825639 20.888303 0 11.530344-9.462402 20.888304-20.825639 20.888304h-109.893365c9.545955 16.000441 7.478013 36.972297-6.41271 50.863019a41.672166 41.672166 0 0 1-59.072122 0L776.460024 960.861969z m76.367638-41.776607h66.424806c22.977134 0 41.609501-18.59059 41.609501-41.881049V270.461756c0-22.559368-18.047494-40.690416-40.314426-40.690416H416.303892c-22.266932 0-40.314426 18.214601-40.314426 40.690416v606.742557c0 23.123352 18.799473 41.881049 41.588613 41.881049h317.084449l-10.736588-10.757477a41.693054 41.693054 0 0 1-10.861918-40.377091l-19.718558-19.739447A146.259902 146.259902 0 0 1 502.363703 627.693525a146.218126 146.218126 0 0 1 220.517822 190.981761l19.739447 19.739447a41.630389 41.630389 0 0 1 40.377091 10.841029L852.827662 919.085362zM1002.638576 814.643843h62.852906A41.797496 41.797496 0 0 0 1107.080095 772.867236V167.106429c0-23.14424-18.632367-41.776607-41.588613-41.776607H563.775316A41.797496 41.797496 0 0 0 522.207592 167.106429v20.888304h396.794216A83.448773 83.448773 0 0 1 1002.638576 271.443506V814.643843zM266.325872 46.998683h31.123572c8.773088 0 15.875111 6.955805 15.875111 15.666228 0 8.647758-7.102023 15.666228-15.875111 15.666228h-31.123572v31.123572c0 8.773088-6.955805 15.875111-15.666228 15.875111a15.770669 15.770669 0 0 1-15.666228-15.875111V78.331139H203.869844A15.728893 15.728893 0 0 1 187.994733 62.664911c0-8.647758 7.102023-15.666228 15.875111-15.666228h31.123572V15.875111c0-8.773088 6.955805-15.875111 15.666228-15.875111 8.647758 0 15.666228 7.102023 15.666228 15.875111v31.123572zM20.888304 939.973665c0-11.530344 9.462402-20.888304 20.825638-20.888303h125.455152c11.488567 0 20.825639 9.274407 20.825639 20.888303 0 11.530344-9.462402 20.888304-20.825639 20.888304H41.713942A20.80475 20.80475 0 0 1 20.888304 939.973665z m658.733544-135.021995a104.441518 104.441518 0 1 0-147.722083-147.722083 104.441518 104.441518 0 0 0 147.722083 147.722083zM459.542681 313.324555a20.888304 20.888304 0 0 1 20.867415-20.888304H710.202325a20.888304 20.888304 0 1 1 0 41.776608H480.430984A20.825639 20.825639 0 0 1 459.542681 313.324555z m0 104.441518c0-11.530344 9.295295-20.888304 20.742085-20.888303h334.505295c11.44679 0 20.742086 9.274407 20.742086 20.888303 0 11.530344-9.295295 20.888304-20.742086 20.888304H480.284766A20.762974 20.762974 0 0 1 459.542681 417.766073z m0 104.441519c0-11.530344 9.316183-20.888304 20.846527-20.888304h146.301679c11.509455 0 20.846527 9.274407 20.846527 20.888304 0 11.530344-9.316183 20.888304-20.846527 20.888303h-146.301679A20.80475 20.80475 0 0 1 459.542681 522.207592zM62.664911 396.87777a62.664911 62.664911 0 1 1 0-125.329822 62.664911 62.664911 0 0 1 0 125.329822z m0-31.332456a31.332456 31.332456 0 1 0 0-62.664911 31.332456 31.332456 0 0 0 0 62.664911zM1357.739739 271.547948a62.664911 62.664911 0 1 1 0-125.329822 62.664911 62.664911 0 0 1 0 125.329822z m0-31.332456a31.332456 31.332456 0 1 0 0-62.664911 31.332456 31.332456 0 0 0 0 62.664911z"
                      fill="#8A96A3"
                      p-id="5577"
                    ></path>
                  </svg>
                  <br />
                  <span>暂无班级</span>
                </div>

                <el-row>
                  <el-col :span="6" v-for="item in classList" :key="item.id">
                    <div class="classlist" @click="handleClassClick(item.id)">
                      <div
                        class="class_img"
                        :style="{
                          backgroundImage:
                            'url(' + item.curriculumInfo.img_url + ')',
                        }"
                      ></div>
                      <div class="class_room">
                        <el-row>
                          <el-col :span="24">
                            <div class="classname">
                              <el-tooltip
                                class="item"
                                effect="dark"
                                :content="item.name"
                                placement="top"
                              >
                                <span style="float: left" class="txt">
                                  {{ item.name }}</span
                                >
                              </el-tooltip>
                            </div>
                          </el-col>
                        </el-row>
                      </div>

                      <div
                        class="class_time"
                        style="margin-top: 10px; overflow: auto"
                      >
                        <span style="float: right; margin-right: 10px">
                          <span style="font-weight: bold; color: #909399"
                            >共</span
                          >
                          {{ item.tchPlanNum }}
                          <!-- {{ item.curriculumInfo.number_of_courses }} -->
                          <span style="font-weight: bold; color: #909399"
                            >节</span
                          >
                        </span>

                        <el-tag
                          size="mini"
                          style="float: left; margin-right: 10px"
                          v-if="item.curriculum_class_type === 2"
                          >试听班</el-tag
                        >

                        <el-tag
                          size="mini"
                          style="float: left; margin-right: 10px"
                          v-if="item.curriculum_class_type === 1"
                          >正式班</el-tag
                        >

                        <!-- <div v-if="item.is_create_timetable != false">
                          <div v-if="item.start_date === null">
                            <span>
                              上课时间1:
                              <span style="color: #e6a23c; margin-left: 5px">暂未排课</span>
                            </span>
                          </div>
                          <div v-else>
                            <el-tooltip
                              v-if="item.start_date"
                              class="item"
                              effect="dark"
                              :content="item.week_str + ' ' + item.time_str"
                              placement="top"
                            >
                              <span>
                                上课时间:
                                <span style="margin-left: 5px">
                                  {{ item.week_str.slice(0, 2)
                                  }}{{ item.time_str.slice(0, 11) }}
                                </span>
                              </span>
                            </el-tooltip>
                          </div>
                        </div>
                        <div v-else>
                          上课时间:
                          <span style="margin-left: 5px">自由上课</span>
                        </div>-->
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="结业班级" name="second">
          <el-row style="text-align: center">
            <div style="margin-top: 20%" v-if="classList1.length == 0">
              <svg
                t="1650598706126"
                class="icon"
                viewBox="0 0 1567 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="5576"
                width="200"
                height="200"
              >
                <path
                  d="M156.662278 699.758173h21.097186A10.444152 10.444152 0 0 1 187.994733 710.202325c0 5.765172-4.490985 10.444152-10.235269 10.444152H156.662278v21.097186A10.444152 10.444152 0 0 1 146.218126 751.978932a10.277045 10.277045 0 0 1-10.444152-10.235269V720.646477H114.676787A10.444152 10.444152 0 0 1 104.441518 710.202325c0-5.765172 4.490985-10.444152 10.235269-10.444152H135.773974v-21.097187A10.444152 10.444152 0 0 1 146.218126 668.425717c5.765172 0 10.444152 4.490985 10.444152 10.235269v21.097187z m1378.628042-83.553215v-21.097186A10.277045 10.277045 0 0 0 1524.846168 584.872503a10.444152 10.444152 0 0 0-10.444152 10.235269v21.097186h-21.097186a10.277045 10.277045 0 0 0-10.235269 10.444152c0 5.598065 4.595427 10.444152 10.235269 10.444152h21.097186v21.097187c0 5.744284 4.67898 10.235269 10.444152 10.235268a10.444152 10.444152 0 0 0 10.444152-10.235268V637.093262h21.097187c5.744284 0 10.235269-4.67898 10.235268-10.444152a10.444152 10.444152 0 0 0-10.235268-10.444152H1535.29032zM776.460024 960.861969H250.596979A20.80475 20.80475 0 0 1 229.77134 939.973665c0-11.530344 9.462402-20.888304 20.825639-20.888303h94.728457A83.010119 83.010119 0 0 1 334.212859 877.413196v-605.96969A83.49055 83.49055 0 0 1 417.849627 187.994733H480.430984V167.001988A83.49055 83.49055 0 0 1 564.067752 83.553215h501.152182A83.448773 83.448773 0 0 1 1148.856702 167.001988v605.969689c0 15.185797-4.052331 29.410732-11.133466 41.672166h115.554096c11.551232 0 20.909192 9.274407 20.909192 20.888304 0 11.530344-9.295295 20.888304-20.888304 20.888304H1002.638576v20.992745c0 15.185797-4.052331 29.410732-11.133466 41.672166h11.196131c11.488567 0 20.825639 9.274407 20.825639 20.888303 0 11.530344-9.462402 20.888304-20.825639 20.888304h-109.893365c9.545955 16.000441 7.478013 36.972297-6.41271 50.863019a41.672166 41.672166 0 0 1-59.072122 0L776.460024 960.861969z m76.367638-41.776607h66.424806c22.977134 0 41.609501-18.59059 41.609501-41.881049V270.461756c0-22.559368-18.047494-40.690416-40.314426-40.690416H416.303892c-22.266932 0-40.314426 18.214601-40.314426 40.690416v606.742557c0 23.123352 18.799473 41.881049 41.588613 41.881049h317.084449l-10.736588-10.757477a41.693054 41.693054 0 0 1-10.861918-40.377091l-19.718558-19.739447A146.259902 146.259902 0 0 1 502.363703 627.693525a146.218126 146.218126 0 0 1 220.517822 190.981761l19.739447 19.739447a41.630389 41.630389 0 0 1 40.377091 10.841029L852.827662 919.085362zM1002.638576 814.643843h62.852906A41.797496 41.797496 0 0 0 1107.080095 772.867236V167.106429c0-23.14424-18.632367-41.776607-41.588613-41.776607H563.775316A41.797496 41.797496 0 0 0 522.207592 167.106429v20.888304h396.794216A83.448773 83.448773 0 0 1 1002.638576 271.443506V814.643843zM266.325872 46.998683h31.123572c8.773088 0 15.875111 6.955805 15.875111 15.666228 0 8.647758-7.102023 15.666228-15.875111 15.666228h-31.123572v31.123572c0 8.773088-6.955805 15.875111-15.666228 15.875111a15.770669 15.770669 0 0 1-15.666228-15.875111V78.331139H203.869844A15.728893 15.728893 0 0 1 187.994733 62.664911c0-8.647758 7.102023-15.666228 15.875111-15.666228h31.123572V15.875111c0-8.773088 6.955805-15.875111 15.666228-15.875111 8.647758 0 15.666228 7.102023 15.666228 15.875111v31.123572zM20.888304 939.973665c0-11.530344 9.462402-20.888304 20.825638-20.888303h125.455152c11.488567 0 20.825639 9.274407 20.825639 20.888303 0 11.530344-9.462402 20.888304-20.825639 20.888304H41.713942A20.80475 20.80475 0 0 1 20.888304 939.973665z m658.733544-135.021995a104.441518 104.441518 0 1 0-147.722083-147.722083 104.441518 104.441518 0 0 0 147.722083 147.722083zM459.542681 313.324555a20.888304 20.888304 0 0 1 20.867415-20.888304H710.202325a20.888304 20.888304 0 1 1 0 41.776608H480.430984A20.825639 20.825639 0 0 1 459.542681 313.324555z m0 104.441518c0-11.530344 9.295295-20.888304 20.742085-20.888303h334.505295c11.44679 0 20.742086 9.274407 20.742086 20.888303 0 11.530344-9.295295 20.888304-20.742086 20.888304H480.284766A20.762974 20.762974 0 0 1 459.542681 417.766073z m0 104.441519c0-11.530344 9.316183-20.888304 20.846527-20.888304h146.301679c11.509455 0 20.846527 9.274407 20.846527 20.888304 0 11.530344-9.316183 20.888304-20.846527 20.888303h-146.301679A20.80475 20.80475 0 0 1 459.542681 522.207592zM62.664911 396.87777a62.664911 62.664911 0 1 1 0-125.329822 62.664911 62.664911 0 0 1 0 125.329822z m0-31.332456a31.332456 31.332456 0 1 0 0-62.664911 31.332456 31.332456 0 0 0 0 62.664911zM1357.739739 271.547948a62.664911 62.664911 0 1 1 0-125.329822 62.664911 62.664911 0 0 1 0 125.329822z m0-31.332456a31.332456 31.332456 0 1 0 0-62.664911 31.332456 31.332456 0 0 0 0 62.664911z"
                  fill="#8A96A3"
                  p-id="5577"
                ></path>
              </svg>
              <br />
              <span>暂无班级</span>
            </div>

            <el-col :span="6" v-for="item in classList1" :key="item.id">
              <div class="classlist1" @click="handleClassClick(item.id)">
                <div
                  class="class_img1"
                  :style="{
                    backgroundImage: 'url(' + item.curriculumInfo.img_url + ')',
                  }"
                ></div>
                <div class="class_room1">
                  <el-row>
                    <el-col :span="24">
                      <div class="classname">
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="item.name"
                          placement="top"
                        >
                          <span style="float: left" class="txt1">
                            {{ item.name }}</span
                          >
                        </el-tooltip>
                      </div>
                    </el-col>
                  </el-row>
                </div>

                <div
                  class="class_time"
                  style="margin-top: 10px; overflow: auto"
                >
                  <span style="float: right; margin-right: 10px">
                    <span style="font-weight: bold; color: #909399">共</span>
                    {{ item.tchPlanNum }}
                    <span style="font-weight: bold; color: #909399">节</span>
                  </span>

                  <el-tag
                    size="mini"
                    style="float: left; margin-left: 10px"
                    v-if="item.curriculum_class_type === 2"
                    >试听班</el-tag
                  >

                  <el-tag
                    size="mini"
                    style="float: left; margin-left: 10px"
                    v-if="item.curriculum_class_type === 1"
                    >正式班</el-tag
                  >
                </div>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog
      title="课程讲义"
      :visible.sync="dialogVisible"
      width="80%"
      top="5vh"
    >
      <div>
        <iframe style="width: 100%; height: 80vh" :src="stu_note_url"></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  stuGetStuClassList,
  stuGetStuTimetable,
} from '@/api/classroom/student_api'

import { dateFormat } from '@/config/_filter'

export default {
  name: 'classlistIndexStu',
  data() {
    return {
      //日期快捷选择
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },

      userSubject: [],
      classList: [],
      userSubject1: [],
      classList1: [],
      currentpage: 1,
      activeName: 'first',

      sizeForm: {
        teaching_type: '', //课程类型
        course_state: '', //班级状态
      },
      stuTchPlanList: [], //我的课表
      stu_note_url: '',
      dialogVisible: false,
      dialogFormVisible: false, //教师点评
      //我的课表页码
      page_no: 1,
      page_size: 10,
      total: 0,
      //学员出勤页码
      page_no1: 1,
      page_size1: 20,
      total1: 0,

      //查看评语
      work_title: '',
      workinfo: {},
      markform: {},
      work_url: '',

      course_time: [],
      moresearch: true,

      teachplan_form: {
        date: [],
        default_time: '', //默认搜索时间
        sign_state: '', //签到状态
        latest: true,
      },
      //作品尺寸适配
      frameWidth: 0, // 屏幕宽
      frameHeight: 0, // 屏幕高
      scale: 0,
    }
  },

  mounted() {
    this.frameWidth = document.documentElement.clientWidth * 0.8 * 0.583 - 50
    this.frameHeight = this.frameWidth * 0.75 + 55

    this.scale = this.frameWidth / 480

    this.teachplan_form.default_time = dateFormat() //获得当前时间

    console.log('默认起始时间')
    console.log(this.teachplan_form.default_time)

    this.stuGetStuClassList()
    // this.stuGetStuTimetable();
    this.stuGetStuClassList1()
  },

  methods: {
    //改变搜索条件
    ChangeSearchState() {
      this.moresearch = !this.moresearch
    },

    onSubmit() {
      console.log('submit!')
      console.log(this.sizeForm)
      console.log(this.currentpage)
    },

    handleCurrentChange(val) {
      this.page_no = val
      this.stuGetStuTimetable()
    },
    handleCurrentChange1(val) {
      this.page_no1 = val
    },

    LatestCourse(e) {
      if (e.target.tagName === 'INPUT') return // 因为原生click事件会执行两次，第一次在label标签上，第二次在input标签上，故此处理

      console.log('最近课程')
      console.log(this.teachplan_form.latest)

      if (!this.teachplan_form.latest) {
        this.teachplan_form.default_time = dateFormat() //获得当前时间
        this.teachplan_form.date = []
      } else {
        this.teachplan_form.default_time = ''
      }
      this.page_no = 1
      this.stuGetStuTimetable()
    },

    //查看学生讲义
    LookNote(note_url) {
      this.stu_note_url = note_url
      this.dialogVisible = true
    },

    //学生历史班级
    stuGetStuClassList1() {
      stuGetStuClassList({
        subject_id: '',
        end_class_state: 1,
        teaching_type: this.sizeForm.teaching_type,
        course_state: this.sizeForm.course_state,
        course_week: '',
        course_time: '',
        page_no: 1,
        page_size: 100,
      }).then((res) => {
        console.log('查询班级列表')
        console.log(res)
        this.userSubject1 = res.userSubject //用户科目

        res.classlist.map((item) => {
          if (item.curriculumInfo == undefined) {
            item.curriculumInfo = {}
            item.curriculumInfo.img_url =
              'https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/static/060798de-c2de-4b7a-9952-3175982472bc/21020-体验.png'
          }
        })
        this.classList1 = res.classlist //班级列表
      })
    },

    //学生班级列表
    stuGetStuClassList() {
      stuGetStuClassList({
        subject_id: '',
        end_class_state: 0,
        teaching_type: this.sizeForm.teaching_type,
        course_state: this.sizeForm.course_state,
        course_week: '',
        course_time: '',
        page_no: 1,
        page_size: 100,
      }).then((res) => {
        console.log('查询班级列表')
        console.log(res, 123456)
        this.userSubject = res.userSubject //用户科目
        res.classlist.map((item) => {
          if (item.curriculumInfo == undefined) {
            item.curriculumInfo = {}
            item.curriculumInfo.img_url =
              'https://steamfun.oss-cn-zhangjiakou.aliyuncs.com/static/060798de-c2de-4b7a-9952-3175982472bc/21020-体验.png'
          }
        })
        this.classList = res.classlist //班级列表
      })
    },

    search() {
      this.page_no = 1
      this.teachplan_form.latest = false
      this.teachplan_form.default_time = ''
      this.stuGetStuTimetable()
    },

    //学生课表
    stuGetStuTimetable() {
      stuGetStuTimetable({
        title: this.teachplan_form.title,
        sign_state: this.teachplan_form.sign_state,
        start_date: '', // 开始时间
        end_date: this.teachplan_form.date ? this.teachplan_form.date[1] : '', // 结束时间
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('查询学生课表')
        console.log(res)
        this.stuTchPlanList = res.tchPlanList
        this.total = res.total
      })
    },

    //上课创作
    CreateWork(item, plan_id, operate) {
      console.log('上课创作')
      console.log(item)
      console.log(plan_id)
      console.log(operate)

      if (item.subject_id == '1') {
        if (operate == '1') {
          //上课创作
          if (item.class_work_url) {
            window.location.href =
              '/jrcode/course.html?mode=edit&role=stu&type=4&filepath=' +
              item.class_work_url +
              '&plan_id=' +
              plan_id +
              '&operate=' +
              operate
          } else {
            window.location.href =
              '/jrcode/course.html?mode=edit&role=stu&type=4&filepath=' +
              item.lessionInfo.teach_template_url +
              '&plan_id=' +
              plan_id +
              '&operate=' +
              operate
          }
        } else if (operate == '2') {
          console.log('继续挑战-课堂模板')
          window.location.href =
            '/jrcode/course.html?mode=edit&role=stu&type=4&filepath=' +
            item.stuTchPlanInfo.classWorkInfo.work_url +
            '&plan_id=' +
            plan_id +
            '&operate=' +
            operate
        } else if (operate == '3') {
          console.log('重新挑战-课后作业')

          if (item.homework_work_url) {
            window.location.href =
              '/jrcode/course.html?mode=edit&role=stu&type=4&filepath=' +
              item.homework_work_url +
              '&plan_id=' +
              plan_id +
              '&operate=' +
              operate
          } else {
            window.location.href =
              '/jrcode/course.html?mode=edit&role=stu&type=4&filepath=' +
              item.lessionInfo.home_template_url +
              '&plan_id=' +
              plan_id +
              '&operate=' +
              operate
          }
        } else if (operate == '4') {
          console.log('继续挑战-课后作业')
          window.location.href =
            '/jrcode/course.html?mode=edit&role=stu&type=4&filepath=' +
            item.stuTchPlanInfo.homeWorkInfo.work_url +
            '&plan_id=' +
            plan_id +
            '&operate=' +
            operate
        }
      } else if (item.subject_id == '2') {
        window.location.href =
          '/scratch/course.html?plan_id=' + plan_id + '&operate=' + operate
      } else if (item.subject_id == '3') {
        this.$router.push({
          name: 'python_course',
          query: {
            type: '2',
            title: item.lessionInfo.title,
            plan_id: plan_id,
            operate: operate,
          },
          params: {
            lessionInfo: item.lessionInfo,
            stuTchPlanInfo: item.stuTchPlanInfo,
          },
        })
      }
    },

    handleClassClick(id) {
      console.log('班级ID')
      console.log(id)
      sessionStorage.setItem('class_id', id),
        this.$router.push({
          name: 'classlistDescStu',
          // name: 'classlistIndexStu1'
          // query: {
          //   class_id: id,
          // },
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.txt {
  overflow: hidden;
}

.school-body-index {
  background: white;
  border-radius: 5px;
  padding-top: 10px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  margin: 20px;

  height: calc(100vh - 110px);

  .classwrapper {
    // overflow-y: scroll;
    background: white;

    .classtype {
      margin-top: 10px;
    }

    .classlist {
      border: 1px solid rgb(226, 226, 226);
      margin: 15px;
      border-radius: 5px;
      padding-bottom: 10px;
      text-align: left;

      .class_img {
        display: block;
        width: 100%;
        height: 0;
        padding-bottom: 69%;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 5px 5px 0px 0px;

        .classimg {
          width: 100%;
          border-radius: 5px 5px 0px 0px;
        }
      }

      .class_room {
        margin-top: 10px;

        .classname {
          overflow: hidden;
          font-weight: 800;
          padding-left: 10px;
          font-size: 16px;
        }
      }

      .class_time {
        padding-left: 10px;
        line-height: 20px;
      }

      .class_num {
        padding-left: 10px;
        line-height: 20px;
      }
    }

    .pagesdiv {
      text-align: center;
      padding: 10px;
    }
  }

  .classlist_wrapper {
    .classlist-imgwrapper {
      .classimg_wrapper_img {
        width: 100%;
        border-radius: 5px;
        margin-top: 7%;
      }
    }

    .classlist-content {
      flex: 1;
      display: flex;
      flex-flow: column;

      .classlist-content-title {
        flex: 1;
        padding-left: 40px;
        font-weight: 500;
        line-height: 30px;

        .coursetitle {
          padding-right: 10px;
          font-weight: 600;
          font-size: 16px;
        }
      }

      .classlist-content-desc {
        flex: 1;

        line-height: 25px;
        padding-left: 40px;
        padding-right: 20px;

        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;

        .content_desc {
          margin-left: 10px;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: center;
        }

        .content-desc {
          padding-right: 20px;
        }
      }

      .classlist-content-date {
        flex: 1;

        line-height: 30px;
        padding-left: 40px;
      }
    }

    .classlist-btn {
      text-align: center;
      margin-top: 18%;

      .drop_btn {
        margin-right: 20px;
      }

      .class_btn {
        margin-right: 20px;
      }
    }

    .pagination-style {
      margin: 20px;
    }
  }
}

.classlist1 {
  border: 1px solid rgb(226, 226, 226);
  margin: 15px;
  border-radius: 5px;
  padding-bottom: 10px;
}

.class_img1 {
  display: block;
  width: 100%;
  height: 0;
  padding-bottom: 69%;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 5px 5px 0px 0px;
}

.classimg1 {
  width: 100%;
  border-radius: 5px 5px 0px 0px;
}

.class_room1 {
  margin-top: 10px;
}

.classname1 {
  overflow: hidden;
  font-weight: 800;
  padding-left: 10px;
  font-size: 16px;
}

.class_time1 {
  padding-left: 10px;
  line-height: 20px;
}

.class_num1 {
  padding-left: 10px;
  line-height: 20px;
}

.txt1 {
  // width: 100px;
  // overflow: hidden;
  // white-space: nowrap;
  // text-overflow: ellipsis;
  font-weight: 800;
  padding-left: 10px;
  font-size: 16px;
}
</style>
